const categories = [
  {
    id: '1039',
    name: 'Sheds',
    path: 'sheds',
  },
  {
    id: '1162',
    name: 'Carports & Pergolas',
    path: 'carports-pergolas',
  },
  {
    id: '135',
    name: 'Dentists',
    path: 'dentists',
  },
  {
    id: '161',
    name: 'Electricians',
    path: 'electricians',
  },
  {
    id: '18',
    name: 'Awnings',
    path: 'awnings',
  },
  {
    id: '220',
    name: 'Removalists',
    path: 'removalists',
  },
  {
    id: '226',
    name: 'Garage Doors',
    path: 'garage-doors',
  },
  {
    id: '268',
    name: 'Hot Water Systems',
    path: 'hot-water-systems',
  },
  {
    id: '2811',
    name: 'Upholstery Cleaning',
    path: 'upholstery-cleaning',
  },
  {
    id: '30',
    name: 'Blinds',
    path: 'blinds',
  },
  {
    id: '322',
    name: 'Locksmiths',
    path: 'locksmiths',
  },
  {
    id: '323',
    name: 'Shutters',
    path: 'shutters',
  },
  {
    id: '365',
    name: 'Mechanics',
    path: 'mechanics',
  },
  {
    id: '408',
    name: 'Patio Builders',
    path: 'patio-builders',
  },
  {
    id: '411',
    name: 'Pest Control',
    path: 'pest-control',
  },
  {
    id: '474',
    name: 'Roofing Contractors',
    path: 'roofing-contractors',
  },
  {
    id: '475',
    name: 'Roof Restorations & Repairs',
    path: 'roof-restorations-repairs',
  },
  {
    id: '48257',
    name: 'Termite Inspections & Treatment',
    path: 'termite-inspections-treatment',
  },
  {
    id: '60',
    name: 'Carpet Cleaning',
    path: 'carpet-cleaning',
  },
  {
    id: '600',
    name: 'Tree & Stump Removal',
    path: 'tree-stump-removal',
  },
  {
    id: '605',
    name: 'Tyres',
    path: 'tyres',
  },
  {
    id: '636',
    name: 'Windscreen Repairs & Replacements',
    path: 'windscreen-repairs-replacements',
  },
  {
    id: '780',
    name: 'Curtains',
    path: 'curtains',
  },
  {
    id: '819',
    name: 'Glass Repairs & Replacements',
    path: 'glass-repairs-replacements',
  },
  {
    id: '8760',
    name: 'Blocked Drains',
    path: 'blocked-drains',
  },
  {
    id: '889',
    name: 'Plumbers',
    path: 'plumbers',
  },
  {
    id: '9',
    name: 'Air Conditioning',
    path: 'air-conditioning',
  },
  {
    id: '905',
    name: 'Security Doors & Screens',
    path: 'security-doors-screens',
  },
];

export default categories;
